import NonWorkingDaysCheckboxSelectField from "components/fields/NonWorkingDaysCheckboxSelectField";
import DynamicTextBox from "components/fields/DynamicTextBoxField";
import {  EventStatePayload } from '../../../../../redux/eventSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';

type CreateEventProps = {
  eventObject?: EventStatePayload;
};
const EventConfig = ({ eventObject }:CreateEventProps) => {

  const event = useSelector((state: RootState) => state.event.payload);
  const options = [
    { value: 'sunday', label: 'Sunday',isChecked: false  },
    { value: 'monday', label: 'Monday',isChecked: false  },
    { value: 'tuesday', label: 'Tuesday',isChecked: false   },
    { value: 'wednesday', label: 'Wednesday',isChecked: false   },
    { value: 'thursday', label: 'Thursday',isChecked: false   },
    { value: 'friday', label: 'Friday',isChecked: false  },
    { value: 'saturday', label: 'Saturday',isChecked: false  }
  ];
  return (
    <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
      {/* Header */}
      <div className="mt-4">
      <NonWorkingDaysCheckboxSelectField
        id="my-checkbox-field"
        label="Non Working Days"
        options={options}
        unavailableDays={eventObject?.unavailableDays}
        payloadUnavailableDays={event.unavailableDays}
      />
      </div>
      <DynamicTextBox payloadUnavailableDates={event.unavailableDates} unavailableDates={eventObject?.unavailableDates} scheduleDays={Number(event.scheduleDays)} />
      
    </div>
  );
};

export default EventConfig;
